var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.382935,
    y: 0.138428,
    width: 43.4971,
    height: 43.4971,
    rx: 8.15571,
    fill: "#EAF6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1315 30.9488C27.1362 30.9488 31.1934 26.8916 31.1934 21.8869C31.1934 16.8821 27.1362 12.825 22.1315 12.825C17.1267 12.825 13.0696 16.8821 13.0696 21.8869C13.0696 26.8916 17.1267 30.9488 22.1315 30.9488Z",
    stroke: "#28A745",
    strokeWidth: 1.35929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1315 27.3242C25.1343 27.3242 27.5686 24.8899 27.5686 21.8871C27.5686 18.8842 25.1343 16.45 22.1315 16.45C19.1286 16.45 16.6943 18.8842 16.6943 21.8871C16.6943 24.8899 19.1286 27.3242 22.1315 27.3242Z",
    stroke: "#28A745",
    strokeWidth: 1.35929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1315 23.6995C23.1324 23.6995 23.9439 22.888 23.9439 21.8871C23.9439 20.8861 23.1324 20.0747 22.1315 20.0747C21.1305 20.0747 20.3191 20.8861 20.3191 21.8871C20.3191 22.888 21.1305 23.6995 22.1315 23.6995Z",
    stroke: "#28A745",
    strokeWidth: 1.35929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.030355e29d9db5a50f0985df3af244ce.svg";
export { ForwardRef as ReactComponent };